import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { getDefaultSettings } from 'http2';
import { MatDialog } from '@angular/material/dialog';
import { FlatPropertiesTestComponent } from '../buildings/flat-properties-test/flat-properties-test.component';



@Component({
  selector: 'app-filtering',
  templateUrl: './filtering.component.html',
  styleUrls: ['./filtering.component.scss']
})



export class FilteringComponent implements OnInit {

  filter: any = {
    numberOfRoomsFrom: 0,
    numberOfRoomsUntil: 0,
    areaFrom: 0,
    areaUntil: 0,
    airDirection: '',
    status: [],
    projects: []
  };
  filterArray: any;
  filterProp: any[];
  buildingTitle: any;
  public compId;
  results: any[] = [];
  // displayedColumns: string[] = ['moreTrigger','numberOfRooms', 'floorNumber', 'airDirection', 'flatSize', 'balconiesSize', 'gardenSize', 
  displayedColumns: string[] = ['moreTrigger', 'numberOfRooms', 'floorNumber', 'airDirection', 'flatSize', 'balconiesSize', 'gardenSize',
    // 'mainSpiricalSrc', 
    'status', 'buildingName', 'projectName'
  ];
  dataSource = new MatTableDataSource<PeriodicElement>(this.results);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  airDirectionArray: any[] = [];
  numberOfRoomsArray: any[] = [];
  statusArray: any[] = [];
  freeStatusCounter: number = 0;
  waitingStatusCounter: number = 0;
  soldStatusCounter: number = 0;
  projects: any;
  url: any;
  public dialog: MatDialog;
  projId: string = '';
  buildingsUid: any = '';
  buildings: any;
  showFilters: boolean = false;
  compTitle: string = '';
  pageSize: number = 8;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @Output() public filteredProjects = new EventEmitter();

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(private route: ActivatedRoute,
    public dataService: DataService,
    private router: Router,) {
    const id = route.snapshot.paramMap.get('id');
    this.compId = id;
    const idp = route.snapshot.paramMap.get('idp');
    this.projId = idp;
  }



  ngOnInit(): void {
    if (window.innerHeight < 800) {
      this.pageSize = 5;
    }
    this.url = this.router.url;
    console.log(this.url);
    this.dataService.getSpecComp(this.compId).subscribe(comp => {
      this.compTitle = comp[0].name;
    });
    this.dataService.getItemsByCompId(this.compId).subscribe(projects => {
      console.log('projects', projects);
      this.projects = projects;
    });
    this.dataService.showAllBuildingsByCompId(this.compId).subscribe(buildings => {
      this.buildings = buildings;
      this.getFlats(buildings)
    });
    this.filter = {
      airDirection: "",
      areaFrom: 0,
      areaUntil: 0,
      numberOfRoomsFrom: 0,
      numberOfRoomsUntil: 0,
      projects: [],
      status: []
    }

    // this.updateItem(this.filter);
  }

  openFlat(flat) {
    let curBuilding
    this.buildings.forEach(building => {
      if(building.uid === flat.buildingUid) {
        curBuilding = building;
        return;
      }
    });
       
    let curProject;
    if (curBuilding) {
      this.projects.forEach(project => {
        if(project.id === curBuilding.projId){
          curProject = project;

          let link = "";
          if (curBuilding && curProject ) {
            link = 'company/u/' + this.compId + '/' + curProject.uid + '/building/' + flat.buildingUid + '/' + flat.id;
          } else {
            link = 'company/u/' + this.compId + '/' + flat.projUid + '/building/' + flat.buildingUid + '/' + flat.id;
          }
          window.open(link, '_blank')


          return;
        }
      })
    }
  }



  closeF() {
    this.filter = {
      airDirection: "",
      areaFrom: 0,
      areaUntil: 0,
      numberOfRoomsFrom: 0,
      numberOfRoomsUntil: 0,
      projects: [],
      status: []
    }
    this.updateItem(filter);
  }

  getFlats(buildings) {
    const results = buildings.map((building) => {
      this.buildingTitle = building.name;
      this.buildingsUid = building.uid;
      return building.floors.map(item => {
        return item.floor.flats.filter((flat) => {
          flat.buildingName = building.name;
          flat.buildingUid = this.buildingsUid;
          if (!this.airDirectionArray.includes(flat.airDirection)) {
            if (flat.airDirection && flat.airDirection !== "") {
              this.airDirectionArray.push(flat.airDirection);
            }
          }
          if (!this.numberOfRoomsArray.includes(+flat.numberOfRooms)) {
            if (flat.numberOfRooms > 0 && flat.numberOfRooms) {
              this.numberOfRoomsArray.push(+flat.numberOfRooms);
              this.numberOfRoomsArray.sort(function (a, b) {
                return a - b;
              });
            }
            // return flat.airDirection;
          }

          if (flat.status !== "") {
            if (flat.status === 'free') {
              this.freeStatusCounter = this.freeStatusCounter + 1;
            }
            if (flat.status === 'waiting') {
              this.waitingStatusCounter = this.waitingStatusCounter + 1;
            }
            if (flat.status === 'sold') {
              this.soldStatusCounter = this.soldStatusCounter + 1;
            }
          }

          if (!this.statusArray.includes(flat.status)) {
            if (flat.status !== "") {
              this.statusArray.push(flat.status);
            }
            // return flat.airDirection;
          }
          return false;
        });
      })
    });
    console.log(this.airDirectionArray, this.numberOfRoomsArray);

  }

  updateItem(filter) {
    filter.numberOfRoomsFrom = +filter.numberOfRoomsFrom;
    filter.numberOfRoomsUntil = +filter.numberOfRoomsUntil;

    this.dataSource.paginator = this.paginator
    this.dataSource.data = [];
    let resultArray = [];
    let lastBuilding = false;
    let lastFlat = false;
    if (filter.projects.length > 0) {
      filter.projects.map(project => {
        this.dataService.showAllBuildingsByProjId(project).subscribe(buildings => {
          if (buildings.length > 0) {
            getFlatsUpdate(buildings);
          }
        });
      });
    } else {

      this.dataService.showAllBuildingsByCompId(this.compId).subscribe(buildings => {
        console.log(buildings);
        getFlatsUpdate(buildings);
      });
    }

    let getFlatsUpdate = (buildings) => {
      console.log(buildings);
      const results = buildings.map((building, i) => {
        console.log(i);
        if (i + 1 === buildings.length) {
          lastBuilding = true;
        }

        this.buildingTitle = building.name;
        this.buildingsUid = building.uid;
        return building.floors.map(item => {
          return item.floor.flats.filter((flat, i, array) => {
            flat.buildingName = building.name;
            flat.buildingUid = this.buildingsUid;
            flat.projName = building.projTitle;
            resultArray.push(flat);
            console.log(i);
            if (i + 1 === array.length) {
              lastFlat = true;
            }
            return flat;
          });
        })
      });

      if (lastBuilding) {
        if (lastFlat) {
          // this.results = resultArray;
          if ((filter.numberOfRoomsFrom === 0 && filter.numberOfRoomsUntil === 0)
            && filter.airDirection === "" &&
            (filter.areaFrom === 0 && filter.areaUntil === 0)
            && filter.status.length === 0 && filter.projects.length === 0) {
            this.dataSource.paginator = this.paginator
            this.dataSource.data = resultArray;
          } else {
            this.filteringResults(resultArray, filter);
          }
        }
      }
    }
    this.filteredProjects.emit(filter.projects);
  }



  filteringResults(value: any, filterValue: any) {

    let result = [];
    if (value === 0 || filterValue === 0) {
      return value;
    }

    value.forEach(item => {
      let resultArray = [];
      if (filterValue.numberOfRoomsFrom > 0 || filterValue.numberOfRoomsUntil > 0) {
        const from = +filterValue.numberOfRoomsFrom;
        const until = +filterValue.numberOfRoomsUntil;
        const numOfRooms = +item.numberOfRooms;
        if (this.fromUntil(from, until, numOfRooms)) {
          resultArray.push(item);
        } else {
          return resultArray;
        }
      }

      if (filterValue.areaFrom > 0 || filterValue.areaUntil > 0) {
        const from = +filterValue.areaFrom;
        const until = +filterValue.areaUntil;
        let flatSize = 0;
        if (typeof (item.flatSize) !== 'number') {
          flatSize = +item.flatSize.replace(/[^.\d]/g, '');
        }
        if (this.fromUntil(from, until, flatSize)) {
          resultArray.push(item);
        } else {
          return resultArray;
        }
      }

      if (filterValue.airDirection !== "") {
        if (item.airDirection === filterValue.airDirection) {
          resultArray.push(item);
        } else {
          return resultArray;
        }
      }

      if (filterValue.status.length !== 0) {
        if (filterValue.status.includes(item.status)) {
          resultArray.push(item);
        } else {
          return resultArray;
        }
      }

      if (filterValue.projects.length !== 0) {
        resultArray.push(item);
      }
      result.push(resultArray[0]);
    });
    this.dataSource.paginator = this.paginator
    this.dataSource.data = result;
    console.log(result)
    return result;
  }

  fromUntil(from, until, itemNum) {

    const numOfRooms = +itemNum;
    if (from && until) {
      if (from <= numOfRooms && numOfRooms <= until) {
        return true;
      }
    }
    if (from && until === 0) {
      if (from <= numOfRooms) {
        return true;
      }
    }
    if (from === 0 && until) {
      if (numOfRooms <= until) {
        return true;
      }
    }
    if (!(from <= numOfRooms && numOfRooms <= until) && !(from && until === 0) && !(from === 0 && until)) {
      return false;
    }
  }
}




export interface PeriodicElement {
  numberOfRooms: number;
  floorNumber: number;
  airDirection: string;
  flatSize: number;
  balconiesSize: number;
  gardenSize: number;
  status: number;
  buildingName: number;
  // mainSpiricalSrc: string;
}

